import axios from 'axios'
import moment from 'moment'
export default {
    namespaced: true,
    state: {
        message: {},
        messages: [],
        request: false,
        botmessage: null
    },
    mutations: {
        MESSAGE(state, message) {
            state.message = message
        },
        REQUEST(state, request) {
            state.request = request
        },
        BOTMESSAGE(state, message) {
            state.botmessage = message
        },
        MESSAGES(state, messages) {
            state.messages = messages
        }
    },
    actions: {
        initChat({ commit}, data) {
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_BASE_URL+'RafaelPolloBritoInDaHouse', data)
                .then(response => {
                    // response.data.messages.map(el => {
                    //     el.author = 'bot'
                    //     el.time = moment().locale('ve').format('hh:mm:ss a')
                    //     commit('MESSAGE', el)
                    // })
                    commit('MESSAGES', response.data.messages.map(el => {
                        el.author = 'bot'
                        el.time = moment().locale('ve').format('hh:mm:ss a')
                        return el
                    }))
                    resolve(response.data.messages)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        sendMessage({ commit }, message) {
            commit('MESSAGE', message)
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_BASE_URL + 'RafaelPolloBritoInDaHouse', message)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        call_api({ commit }, data) {
            commit('REQUEST', true)
            let form = new FormData();
            Object.keys(data).forEach(key => form.append(key, data[key]));
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_BASE_URL + 'RafaelPolloBritoInDaHouse')
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        }
    },
    getters: {
        get_message: state => { return state.message },
        get_messages: state => { return state.messages }
    }
}